var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InJzxTool',{on:{"event-handle":_vm.eventHandle}})
}
var staticRenderFns = []

export { render, staticRenderFns }